<template>
    <div class="sealList">
        <div class="seal_title">
            <div class="title">印章申请</div>
            <div class="btn" @click="handlAddSeal">第一步:添加印模</div>
            <div class="btn" @click="sealDialogVisible = true">第二步:添加印章</div>
        </div>
        <div class="seal_message">
            <div class="for" v-for="(item,index) in sealList" :key="index">
                <div class="img">
                    <!-- <img :src="'data:image/png;base64,'+ item.stampTemplateBase64"/> -->
                     <img :src="$global.Local + item.stampTemplate"/>
                </div>
                <div class="btn" @click="handlDele(item)">
                    删除
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="sealDialogVisible" width="30%" center id="sealDialog">
            <div class="all">
                <router-link to="/addOnePerSeal">
                    <div class="perSeal">
                        <img src="../../../../static/img/vip_Ren.png"/>
                        个人印章
                    </div>
                </router-link>
                <!-- <router-link to="/entSeal"> -->
                <div class="entSeal" @click="handlJump">
                    <img src="../../../../static/img/vip-Qi.png"/>
                    企业印章
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sealDialogVisible: false,
                options: [{
                    value: '选项1',
                    label: '个人印章'
                }, {
                    value: '选项2',
                    label: '企业印章'
                }],
                value: '',
                sealList: []
            }
        },
        mounted() {
            let param = new FormData();
            param.append('token', this.$global.token);
            this.getData(param);
        },
        methods: {
            handlJump() {
                console.log(this.$global.webData);
                // this.$router.push('entSeal')
                if (this.$global.webData.farenCode) {
                    this.$router.push('entSeal')
                } else {
                    this.$message.info('请先进行企业认证')
                    this.$router.push('authen')
                }

            },
            handlDele(item) {
                // delStampInfo
                let _this = this;

                _this.$confirm('此操作将永久删除该印模, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let formData = new FormData();
                    formData.append('token', _this.$global.token);
                    formData.append('id', item.id);
                    _this.api.delStampInfo(formData).then(res => {
                        console.log(res);
                      if (res.code !== 0) {
                        return _this.$message.error('服务繁忙');
                        if(res.code === 500){
                          _this.$message.success(res.msg);
                        }
                      }else{
                        _this.$message.success('删除成功');
                        let param = new FormData();
                        param.append('token', _this.$global.token);
                        _this.getData(param);
                      }
                    })
                }).catch(() => {
                });


            },
            getData(param) {
                let _this = this;
                _this.api.getStampList(param).then(res => {
                    _this.sealList = res.data;
                    console.log(_this.sealList);
                })
            },
            handlAddSeal() {
                this.$router.push('perSeal');
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #sealDialog /deep/ .el-dialog {
        background-color: #ffffff;
        border-radius: 30px;
        border: solid 1px #aaaaaa;
        width: 35% !important;

        .all {
            width: auto;
            height: auto;
            display: flex;
            justify-content: center;

            .perSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                letter-spacing: 2px;
                color: #ffffff;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }

            .entSeal {
                width: 240px;
                height: 240px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                margin-left: 40px;
                letter-spacing: 2px;
                color: #ffffff;
                cursor: pointer;
                @column();

                img {
                    width: 66px;
                    height: 62px;
                    margin-bottom: 33px;
                    object-fit: cover;
                }
            }
        }
    }

    .sealList {
        width: @a;
        height: auto;
        margin-left: 4%;

        .seal_title {
            width: 1090px;
            height: 40px;
            display: flex;
            align-items: center;

            .title {
                width: 180px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .btn {
                width: 150px;
                height: 40px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                letter-spacing: 1px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                margin-left: 23px;
                cursor: pointer;
                font-size: 16px;
            }

            .select {
                width: 245px;
                height: 40px;
                margin-left: 550px;
            }
        }

        .seal_message {
            width: @a;
            height: auto;

            .for:nth-child(4n+1) {
                margin-left: 0;
            }

            .for {
                width: auto;
                height: 185px;
                background-color: #ffffff;
                border: solid 1px #aaaaaa;
                display: inline-block;
                margin-left: 35px;
                margin-top: 30px;

                .img {
                    width: 244px;
                    height: 140px;
                    background-color: #ffffff;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: contain;
                    }
                }

                .btn {
                    width: 244px;
                    height: 46px;
                    background-color: #f5f5f5;
                    line-height: 46px;
                    text-align: end;
                    letter-spacing: 1px;
                    color: #333333;
                    padding-right: 20px;
                    cursor: pointer;
                    border-bottom: solid 1px #aaaaaa;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/seal/sealList.vue